import { TabsProps } from 'antd';
import React from 'react';

import { VirtualTourProvider } from '../../../../../shared/ui/VirtualTour/VirtualTourProvider';

export const tabs: TabsProps['items'] = [
    {
        label: (
            <div ref={VirtualTourProvider.get()?.communitiesOverviewRef}>
                Управление
            </div>
        ),
        key: 'manage',
    },
    {
        label: <div>Мониторинг</div>,
        key: 'monitoring',
    },
    {
        label: (
            <div ref={VirtualTourProvider.get()?.communitiesScenariosRef}>
                Сценарии
            </div>
        ),
        key: 'rules',
    },
    {
        label: (
            <div ref={VirtualTourProvider.get()?.communitiesMembersRef}>
                Участники
            </div>
        ),
        key: 'members',
    },
    {
        label: (
            <div ref={VirtualTourProvider.get()?.communitiesEventsRef}>
                События
            </div>
        ),
        key: 'events',
    },
    {
        label: (
            <div ref={VirtualTourProvider.get()?.communitiesKnowledgeRef}>
                База знаний
            </div>
        ),
        key: 'knowledge',
    },
    {
        label: (
            <div ref={VirtualTourProvider.get()?.communitiesAIKnowledgeRef}>
                База знаний ИИ
            </div>
        ),
        key: 'ai-knowledge',
    },
    {
        label: <div>Рекомендации</div>,
        key: 'recommendations',
    },
];
